if (!customElements.get('kan-availability')) {
  customElements.define('kan-availability', class extends HTMLElement {
    constructor() {
      super();
      this.frame = null;
      this.update = () => {
        this.frame = null;
        const scope = this.closest('main') || document;
        const reason = scope.querySelector(`[data-kan-reason="${this.dataset.startReason || '3'}"]`);
        const offer = scope.querySelector('.kan-offer');
        if (offer) this.querySelector('[data-kan-scroll-offer]').setAttribute('href', `#${offer.id}`);
        const visible = Boolean(reason && reason.getBoundingClientRect().top < window.innerHeight);
        this.toggleAttribute('data-visible', visible);
        this.inert = !visible;
        this.setAttribute('aria-hidden', String(!visible));
      };
      this.queueUpdate = () => {
        if (this.frame === null) this.frame = requestAnimationFrame(this.update);
      };
      this.scrollToOffer = (event) => {
        if (!event.target.closest('[data-kan-scroll-offer]')) return;
        const offer = (this.closest('main') || document).querySelector('.kan-offer__card');
        if (!offer) return;
        event.preventDefault();
        offer.scrollIntoView({
          block: 'start',
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      };
    }

    connectedCallback() {
      this.addEventListener('click', this.scrollToOffer);
      window.addEventListener('scroll', this.queueUpdate, { passive: true });
      window.addEventListener('resize', this.queueUpdate);
      window.addEventListener('pageshow', this.queueUpdate);
      document.addEventListener('shopify:section:load', this.queueUpdate);
      document.addEventListener('shopify:section:unload', this.queueUpdate);
      this.resizeObserver = new ResizeObserver(this.queueUpdate);
      this.resizeObserver.observe(this.closest('main') || document.body);
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.scrollToOffer);
      window.removeEventListener('scroll', this.queueUpdate);
      window.removeEventListener('resize', this.queueUpdate);
      window.removeEventListener('pageshow', this.queueUpdate);
      document.removeEventListener('shopify:section:load', this.queueUpdate);
      document.removeEventListener('shopify:section:unload', this.queueUpdate);
      this.resizeObserver.disconnect();
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}
